export const deepCopyArray = (arr: any[]): any[] => {
  return arr.map((item: any) => Array.isArray(item) ? deepCopyArray(item) :
    (typeof item === 'object' && item !== null) ? {...item} : item);
}